module.exports = __webpack_public_path__ + "img/[举手].69a9d8ce.svg";